import React from 'react';
import { Outlet } from 'react-router-dom';
import './PlatformLayout.css';

export default function PlatformLayout() {
  return (
    <div className="platform-layout">
      <Outlet />
    </div>
  );
}
